<script lang="ts">
	import { classes } from '$lib/utils';
	export let additionalClass = '';
</script>

<svg
	class={classes('w-6 h-6', additionalClass)}
	height="100%"
	width="100%"
	version="1.1"
	viewBox="0 0 13 13"
	fill="currentColor"
	fill-rule="evenodd"
	clip-rule="evenodd"
	><use xlink:href="#ytp-id-50" />
	<path
		d="M0.293031 1.29301C0.480558 1.10553 0.734866 1.00022 1.00003 1.00022C1.26519 1.00022 1.5195 1.10553 1.70703 1.29301L6.00003 5.58601L10.293 1.29301C10.3853 1.19749 10.4956 1.12131 10.6176 1.0689C10.7396 1.01649 10.8709 0.988908 11.0036 0.987754C11.1364 0.986601 11.2681 1.0119 11.391 1.06218C11.5139 1.11246 11.6255 1.18672 11.7194 1.28061C11.8133 1.3745 11.8876 1.48615 11.9379 1.60905C11.9881 1.73195 12.0134 1.86363 12.0123 1.99641C12.0111 2.12919 11.9835 2.26041 11.9311 2.38241C11.8787 2.50441 11.8025 2.61476 11.707 2.707L7.41403 7L11.707 11.293C11.8892 11.4816 11.99 11.7342 11.9877 11.9964C11.9854 12.2586 11.8803 12.5094 11.6948 12.6948C11.5094 12.8802 11.2586 12.9854 10.9964 12.9877C10.7342 12.99 10.4816 12.8892 10.293 12.707L6.00003 8.414L1.70703 12.707C1.51843 12.8892 1.26583 12.99 1.00363 12.9877C0.741432 12.9854 0.49062 12.8802 0.305212 12.6948C0.119804 12.5094 0.0146347 12.2586 0.0123563 11.9964C0.0100779 11.7342 0.110873 11.4816 0.293031 11.293L4.58603 7L0.293031 2.707C0.10556 2.51948 0.000244141 2.26517 0.000244141 2C0.000244141 1.73484 0.10556 1.48053 0.293031 1.29301Z"
	/>
	/>
</svg>
